Vue.component('report-follow-up', require('./ReportFollowUp').default);